module.exports = "../../app/cells/components/create_account_cell.rb";